import * as Sentry from '@sentry/react';
import { Flex } from 'antd';
import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { API_STATUS_CODE } from '@/constants/api.constants';

import { Header } from '../layouts/header';
import { CommonError } from './common-error';
import { NotFoundError } from './notfound-error';

export function ErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <>
      <Header includeSetting={false} />
      <Flex
        flex={1}
        align="center"
        justify="center"
        className="page-error-boundary"
      >
        {isRouteErrorResponse(error) &&
        error.status === API_STATUS_CODE.notFound ? (
          <NotFoundError />
        ) : (
          <CommonError />
        )}
      </Flex>
    </>
  );
}
